__turbopack_context__.v({
  "spacer": "styles-module-scss-module__5-Fgsq__spacer",
});
